export default __webpack_public_path__ + "static/media/Segoe-UI-Italic.eb9dca89.woff";